import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import * as action from './store/action-types';
import * as mutation from './store/mutation-types';

import Home from './../views/Home';
import EntryFormView from './../views/entry-form';
import EntrySuccessView from './../views/entry-success';
import TermsConditionsView from './../views/terms-conditions';

// import AshleyTestView from './../views/ashley-test';
import {
  ROUTE_NAMES, errors, ROUTE_PATHS, ENTRY_ROUTES, ROUTE_QUERY_PARAMS
} from './config';
import iframeChannel from './iframe-channel';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: ROUTE_PATHS[ROUTE_NAMES.home],
      name: ROUTE_NAMES.home,
      component: Home,
      beforeEnter: async (to, from, next) => {
        iframeChannel.solidHeader(false);
        const promises = [
          store.dispatch(action.SUBMISSION_VIEW_GET_SUBMISSIONS, { checkBuffer: true })
        ];
        if (to.query[ROUTE_QUERY_PARAMS.submissionId]) {
          promises.push(store.dispatch(action.SUBMISSION_VIEW_GET_SUBMISSION, { submissionId: to.query.submission }));
        } else {
          iframeChannel.scrollTo({ noScroll: true, target: document.body });
        }

        await Promise.all(promises);
        next();
      }
    },
    {
      path: ROUTE_PATHS[ROUTE_NAMES.entryForm],
      name: ROUTE_NAMES.entryForm,
      component: EntryFormView,

      /**
       * Route guard for the submission form. User must be logged in to see.
       * If the user is logged out while on this page, they will be required to log in again when they submit.
       *
       * @param {*} to
       * @param {*} from
       * @param {Function} next
       * @returns {null}
       */
      beforeEnter: async (to, from, next) => {
        if (!store.getters['ui/contestActive']) {
          next(ROUTE_PATHS[ROUTE_NAMES.home]);
          return;
        }
        try {
          await store.dispatch(action.SUBMISSION_GET_USER_SUBMISSION);
        } catch (e) {
          const error = e instanceof Error ? e : new Error(errors.SUBMISSION_SERVER_ERROR);
          next(error);
          return;
        }

        if (store.getters['user/madeSubmission']) {
          // submission is complete
          next({
            replace: true,
            name: ROUTE_NAMES.entrySuccess
          });
          return;
        }
        iframeChannel.solidHeader(true);
        iframeChannel.scrollTo({ noScroll: true, target: document.body });

        next();
      },
    },
    {
      path: ROUTE_PATHS[ROUTE_NAMES.entrySuccess],
      name: ROUTE_NAMES.entrySuccess,
      component: EntrySuccessView,

      /**
       * Route guard for the submission success page. User must be logged in and have a submission associated with them to see.
       *
       * @param {*} to
       * @param {*} from
       * @param {Function} next
       * @returns {null}
       */
      beforeEnter: async (to, from, next) => {
        try {
          const userHasSubmission = await store.dispatch(action.SUBMISSION_GET_USER_SUBMISSION);
          if (!userHasSubmission) {
            throw new Error(errors.SUBMISSION_NO);
          }
        } catch (e) {
          // no submission, no success page
          const error = e instanceof Error ? e : new Error(errors.SUBMISSION_SERVER_ERROR);
          next(error);
          return;
        }
        iframeChannel.solidHeader(true);
        iframeChannel.scrollTo({ noScroll: true, target: document.body });

        next();
      },
    },
    {
      path: ROUTE_PATHS[ROUTE_NAMES.terms],
      name: ROUTE_NAMES.terms,
      component: TermsConditionsView,
      beforeEnter(to, from, next) {
        iframeChannel.solidHeader(false);
        iframeChannel.scrollTo({ noScroll: true, target: document.body });
        next();
      }
    },
    {
      path: '*',
      redirect: { name: ROUTE_NAMES.home },
    },
  ],
});

router.beforeEach((to, from, next) => {
  // set whether this route should have the Entry forms "redBull login" theme
  store.commit(mutation.UI_SET_ENTRY_VIEW, { value: ENTRY_ROUTES.includes(to.name) });
  next();
});

router.onError((error) => {
  console.error('ROUTE ERROR', error);
  router.push({ name: ROUTE_NAMES.home });
});


export default router;
